import { useTranslation } from 'react-i18next'
import { faqPageJsonLd, organizationJsonLd } from '../lib/structuredData'
import { AI } from '../sections/AI'
import { CallToAction } from '../sections/CallToAction'
import { Cases } from '../sections/Cases'
import { FAQ } from '../sections/FAQ'
import { Footer } from '../sections/Footer'
import { Header } from '../sections/Header'
import { Hero } from '../sections/Hero'
import { SEO } from '../sections/SEO'
import { Team } from '../sections/Team'
import { Video } from '../sections/Video'

export const Home = () => {
  const { t } = useTranslation('faq')
  const faqItems = t('items', { returnObjects: true }) as {
    question: string
    answer: string
  }[]

  return (
    <>
      <SEO
        page="home"
        path="/"
        jsonLd={[organizationJsonLd, faqPageJsonLd(faqItems)]}
      />
      <Header />
      <main>
        <Hero />
        <Cases />
        <AI />
        <Video />
        <Team />
        <FAQ />
        <CallToAction />
      </main>
      <Footer />
    </>
  )
}
